import { render, staticRenderFns } from "./InsertButton.vue?vue&type=template&id=13554374&scoped=true"
import script from "./InsertButton.vue?vue&type=script&lang=js"
export * from "./InsertButton.vue?vue&type=script&lang=js"
import style0 from "./InsertButton.vue?vue&type=style&index=0&id=13554374&prod&lang=less"
import style1 from "./InsertButton.vue?vue&type=style&index=1&id=13554374&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13554374",
  null
  
)

export default component.exports